<template>
  <p class="panel-title">{{ $t('app.campaign.newPage.recap.evaluationSection.title') }}</p>
  <div @keydown.enter="save" tabindex="0" class="evaluation-panel-content">
    <div>
      <p>{{ $t('app.campaign.newPage.recap.evaluationSection.adventureDurationText') }}&nbsp;<span class="bold">{{ skillsStore.getAdventureDuration(state?.campaign?.assessment?.modules || []) }} minutes</span></p>
      <p>{{ $t('app.campaign.newPage.recap.evaluationSection.count') }}&nbsp;<span class="bold">{{ passedModuleCount }}/{{ totalModuleCount }}</span></p>
    </div>
    <NewPonderation v-if="state.campaign" class="ponderation" v-model="state.campaign"></NewPonderation>
    <div class="edit-buttons">
      <Button class="secondary" :label="$t('app.campaign.newPage.slidingPanel.buttons.cancel')" @click="emit('close')"></Button>
      <Button class="green" :label="$t('app.campaign.newPage.slidingPanel.buttons.save')" @click="save"></Button>
    </div>
    <div class="footer-text">
      <p v-safe-html="$t('app.campaign.newPage.slidingPanel.evaluation.footer1')"></p>
      <p v-if="false">{{ $t('app.campaign.newPage.slidingPanel.evaluation.footer2') }}</p>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "@/assets/style/variables.scss";

.panel-title {
  color: var(--secondary-color);
  font-family: $bioSans;
  font-size: 20px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin-bottom: 32px;
}

.edit-buttons {
  width: 100%;
  display: flex;
  gap: 12px;
  justify-content: end;
}

.evaluation-panel-content {
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 80vw;
  height: 100%;

  .ponderation {
    height: 50%;
  }

  .footer-text {
    color: var(--secondary-color);
    font-family: $bioSans;
    font-size: 14px;
    font-style: italic;
    font-weight: 400;
    line-height: normal;
  }
}
</style>

<script setup lang="ts">
import { CampaignCreation } from '@/types/campaign';
import NewPonderation from '../NewPonderation.vue';
import { moduleLabels } from '@/types/campaign';

const skillsStore = useSkillsStore();

const totalModuleCount = computed(() => {
  return moduleLabels.filter((label) => label !== 'social_desirability' && label !== 'self_efficacy').length;
});

const passedModuleCount = computed(() => {
  return state?.campaign?.assessment?.modules?.filter((m) => m !== 'social_desirability' && m !== 'self_efficacy').length || 0;
});

const props = defineProps<{
  campaign: CampaignCreation,
}>();

const state = reactive<{
  campaign: CampaignCreation
}>({
  campaign: undefined
});

const emit = defineEmits<{
  (e: 'valid', value: boolean): void,
  (e: 'save', value: CampaignCreation): void,
  (e: 'close'): void
}>();

function save() {
  emit('save', structuredClone(toRaw(state.campaign)));
  emit('close');
}

watch(props.campaign, (newCampaign, oldCampaign) => {
  if (newCampaign) {
    state.campaign = structuredClone(toRaw(newCampaign));
  }
})

onMounted(() => {
  if (props.campaign) {
    state.campaign = structuredClone(toRaw(props.campaign));
  }
});

</script>